module.exports = __webpack_public_path__ + "static/media/trial2 copy.c2ecf4e4.JPG";